module.exports = __webpack_public_path__ + "img/technologyOption.73b16ce1.png";